import { render } from "./HelpAttachMaterialRoute.vue?vue&type=template&id=41d34d66"
import script from "./HelpAttachMaterialRoute.vue?vue&type=script&lang=js"
export * from "./HelpAttachMaterialRoute.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__